import { FETCH_FASTAG_CONFIG_SUCCESS } from '../actions/fastag/fastag.actiontype';

const INITIAL_STATE = {
  config: {},
  isConfigFetched: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_FASTAG_CONFIG_SUCCESS:
      return {
        ...state,
        config: {
          ...state.config,
          ...action.data,
        },
        isConfigFetched: true,
      };
    default:
      return state;
  }
};

export default reducer;
